import { useRouteParams } from '../../hooks/useRouteParams';
import { useRefreshMutation } from './useRefreshMutation';

export const useRefresh = () => {
  const { accountId, clientId, groupId } = useRouteParams();

  const { mutate: refresh, isLoading: isRefreshing } = useRefreshMutation({ clientId });

  return {
    refresh: () => refresh({ clientId, accountId, groupId }),
    isRefreshing,
  };
};
